/**
 * CERES-DP-014 (ADR-060 §4) — TELA DE BLOQUEIO POR INADIMPLÊNCIA.
 *
 * Quando a API responde 403 `ASSINATURA_SUSPENSA` (passados três dias do
 * vencimento sem pagamento), a operação inteira fica fechada no servidor. Esta
 * tela explica o que aconteceu, diz que os dados estão preservados e leva à
 * cobrança, a única área aberta. Em Plano e cobrança ela não aparece, para não
 * cobrir justamente o lugar de regularizar.
 */

import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { registrarAvisoDeBloqueio } from '../lib/api';
import { t } from '../lib/i18n';

export function BloqueioPorInadimplencia(): JSX.Element | null {
  const [bloqueada, setBloqueada] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    registrarAvisoDeBloqueio(() => setBloqueada(true));
    return () => registrarAvisoDeBloqueio(null);
  }, []);

  if (!bloqueada || pathname.startsWith('/plano')) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="bloqueio-titulo"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink/40 p-4"
    >
      <div className="panel max-w-md">
        <h2 id="bloqueio-titulo" className="mb-2 text-sm font-medium text-danger-700">
          {t('dp014.bloqueio.titulo')}
        </h2>
        <p className="mb-2 text-xs text-ink">{t('dp014.bloqueio.texto')}</p>
        <p className="mb-3 text-2xs text-ink-muted">{t('dp014.bloqueio.semPermissao')}</p>
        <Link className="btn-primary" to="/plano" onClick={() => setBloqueada(false)}>
          {t('dp014.bloqueio.irParaCobranca')}
        </Link>
      </div>
    </div>
  );
}
